import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

export type TZebraBleConnectionState = {
  connectionState: 'CONNECTED' | 'DISCONNECTED';
};

export interface ZebraBleModeReaderPlugin {
  /**
   * @description enables and disables SDK initialisation
   * @param options
   */
  setZebraEnabled(options: { enabled: boolean }): Promise<void>;

  /**
   * @description Shows barcode to connect Zebra scanner in BLE mode
   */
  showConnectDeviceBarcode(): Promise<void>;

  /**
   * @description Disconnects connected zebra scanner in ble mode
   */
  disconnectScanner(): Promise<void>;

  /**
   * @description subscribes to connection state update
   */
  addListener(
    eventName: 'connectionUpdateListener',
    listenerFunc: (info: TZebraBleConnectionState) => void,
  ): Promise<PluginListenerHandle>;

  /**
   * @description subscribes to scanned barcode data, called whenever a barcode is scanned
   */
  addListener(
    eventName: 'onBarcodeScanned',
    listenerFunc: (info: { data: string }) => void,
  ): Promise<PluginListenerHandle>;
}

const ZebraBleModeReader = registerPlugin<ZebraBleModeReaderPlugin>('ZebraBleModePlugin');

export default ZebraBleModeReader;
